import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { type SeveridadeValidade } from '../validade-solicitacao';

/**
 * Vigência da solicitação: data do pedido e data de validade, cada uma num selo, com uma seta entre
 * elas — o mesmo bloco origem→destino que o quadro de serviços já usa.
 *
 * É célula sob medida porque a API declarativa do CustomTable não desenha isto: o `sub` sai SEMPRE
 * abaixo do valor principal (`.custom-table-sub` é bloco com `margin-top`), e aqui os dois selos
 * precisam ficar lado a lado com o glifo no meio.
 *
 * É componente, e não marcação repetida nas três abas, pelo mesmo motivo de `app-identificacao-pessoa`:
 * copiado em cada template, divergiria na primeira alteração.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-vigencia-solicitacao',
    standalone: true,
    templateUrl: './vigencia-solicitacao.html',
    styleUrl: './vigencia-solicitacao.scss'
})
export class VigenciaSolicitacao {
    readonly solicitacao = input<string>('');
    readonly validade = input<string>('');
    /** Só a validade é tingida: ela é um ESTADO. A data do pedido é fato, e cor ali não informaria nada. */
    readonly severidade = input<SeveridadeValidade>('secondary');

    /**
     * A frase que o leitor de tela ouve no lugar dos dois selos.
     *
     * Dois `span` e uma seta não se leem em voz alta como uma frase, e o rótulo da coluna sozinho
     * ("Solicitação e validade") não diz qual data é qual.
     */
    readonly descricao = computed(() => {
        const pedido = this.solicitacao().trim();
        const vence = this.validade().trim();

        if (!pedido && !vence) {
            return 'Sem datas registradas';
        }
        if (!vence) {
            return `Solicitada em ${pedido}`;
        }
        if (!pedido) {
            return `Válida até ${vence}`;
        }
        return `Solicitada em ${pedido}, válida até ${vence}`;
    });
}
